// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1fRJq","additionalInfo":"AgreementModal_additionalInfo__nBtB5"};